import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../Button/Button';
import { ListEntryProps } from './List.interface';

interface ListRowProps {
  entry: ListEntryProps;
  style?: React.CSSProperties;
  onClick?: () => void;
  isSelected?: boolean;
  isSelectable?: boolean;
}

export const ListRow: React.FC<ListRowProps> = ({
  entry,
  style,
  onClick,
  isSelected,
  isSelectable,
}) => {
  const { t } = useTranslation();
  return (
    <li
      tabIndex={0}
      className={cn('listEntry', {
        disabled: entry.disabled,
        selected: isSelected,
        selectable: isSelectable && !entry.disabled,
      })}
      style={{ display: 'flex', alignItems: 'center', ...style }}
    >
      <div
        tabIndex={0}
        className={cn('description', entry.labelWrapperClassName)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onClick && isSelectable) {
            onClick();
          }
        }}
        onClick={isSelectable ? onClick : undefined}
      >
        {entry.avatar && <div className="avatarWrapper">{entry.avatar}</div>}
        <div className={cn('name', entry.labelClassName)}>
          <div className="listEntryLabel">{entry.label}</div>
          {entry.content && <div className="listEntryContent">{entry.content}</div>}
        </div>
      </div>
      {entry.actions && entry.actions.length > 0 && (
        <div className="actions">
          {entry.actions.map((action, index) => (
            <Button
              {...action}
              key={index}
              appearance="transparent"
              aria-label={
                action['aria-label'] ||
                t('list_row_action_aria_label', {
                  defaultValue: '{{label}} - Aktion {{number}}',
                  label: entry.label,
                  number: index + 1,
                })
              }
            />
          ))}
        </div>
      )}
    </li>
  );
};
